import React, { ReactNode } from "react";
import cn from "classnames";
import s from "./LogoListWrapper.module.scss";
import { useHeroSectionContext } from "./HeroSectionContext";

type Props = {
  children: ReactNode;
};

const LogoListWrapper: React.FC<Props> = ({ children }) => {
  const context = useHeroSectionContext();
  const isInHeroSection = context !== undefined;

  return (
    <div
      className={cn({
        [s.inHeroSection]: isInHeroSection,
      })}
    >
      {children}
    </div>
  );
};

export default LogoListWrapper;
